export const capitalStructureLineItemOrdering = [
    'marketCap',
    'enterpriseValue',
    'workingCapital',
    'tangibleAssetValue',
    'netCurrentAssetValue',
    'investedCapital',
    'averageReceivables',
    'averagePayables',
    'averageInventory',
];

export const incomeStatementLineItemOrdering = [
    'revenue',
    'costOfRevenue',
    'grossProfit',
    // 'grossProfitRatio',
    'researchAndDevelopmentExpenses',
    'generalAndAdministrativeExpenses',
    'sellingAndMarketingExpenses',
    'sellingGeneralAndAdministrativeExpenses',
    'otherExpenses',
    'operatingExpenses',
    'costAndExpenses',
    'interestIncome',
    'interestExpense',
    'depreciationAndAmortization',
    'ebitda',
    // 'ebitdaratio',
    'operatingIncome',
    // 'operatingIncomeRatio',
    'totalOtherIncomeExpensesNet',
    'incomeBeforeTax',
    // 'incomeBeforeTaxRatio',
    'incomeTaxExpense',
    'netIncome',
    // 'netIncomeRatio',
    'eps',
    'epsdiluted',
    'weightedAverageShsOut',
    'weightedAverageShsOutDil',
    'weightedAverageSharesOutstanding',
    'weightedAverageSharesOutstandingDiluted',
    'weightedAverageShares',
    'weightedAverageSharesDiluted',
];

export const cashFlowLineItemOrdering = [
    'netIncome',
    'depreciationAndAmortization',
    'deferredIncomeTax',
    'stockBasedCompensation',
    'changeInWorkingCapital',
    'accountsReceivables',
    'inventory',
    'accountsPayables',
    'otherWorkingCapital',
    'otherNonCashItems',
    'netCashProvidedByOperatingActivities',
    'investmentsInPropertyPlantAndEquipment',
    'acquisitionsNet',
    'purchasesOfInvestments',
    'salesMaturitiesOfInvestments',
    'otherInvestingActivites',
    'netCashUsedForInvestingActivites',
    'debtRepayment',
    'commonStockIssued',
    'commonStockRepurchased',
    'dividendsPaid',
    'otherFinancingActivites',
    'netCashUsedProvidedByFinancingActivities',
    'effectOfForexChangesOnCash',
    'netChangeInCash',
    'cashAtEndOfPeriod',
    'cashAtBeginningOfPeriod',
    'operatingCashFlow',
    'capitalExpenditure',
    'freeCashFlow',
];

export const balanceSheetLineItemOrdering = [
    'cashAndCashEquivalents',
    'shortTermInvestments',
    'cashAndShortTermInvestments',
    'netReceivables',
    'inventory',
    'otherCurrentAssets',
    'totalCurrentAssets',
    'totalCurrentAssets',
    'propertyPlantEquipmentNet',
    'Goodwill',
    'intangibleAssets',
    'goodwillAndIntangibleAssets',
    'longTermAssets',
    'taxAssets',
    'otherNonCurrentAssets',
    'totalNonCurrentAssets',
    'otherAssets',
    'totalAssets',
    'accountsPayable',
    'shortTermDebt',
    'taxPayables',
    'deferredRevenue',
    'otherCurrentLiabilities',
    'totalCurrentLiabilities',
    'longTermDebt',
    'deferredRevenueNonCurrent',
    'deferredTaxLiabilitiesNonCurrent',
    'otherNonCurrentLiabilities',
    'totalNonCurrentLiabilities',
    'otherLiabilities',
    'capitalLeaseObligations',
    'totalLiabilities',
    'preferredStock',
    'commonStock',
    'retainedEarnings',
    'accumulatedOtherComprehensiveIncomeLoss',
    'othertotalStockholdersEquity',
    'totalStockholdersEquity',
    'totalEquity',
    'totalLiabilitiesAndStockholdersEquity',
    'minorityInterest',
    'totalLiabilitiesAndTotalEquity',
    'totalInvestments',
    'totalDebt',
    'netDebt',
];

export const returnsLineItemOrdering = [
    'revenueGrowth',
    'grossProfitGrowth',
    'ebitgrowth',
    'operatingIncomeGrowth',
    'netIncomeGrowth',
    'epsgrowth',
    'epsdilutedGrowth',
    'weightedAverageSharesGrowth',
    'weightedAverageSharesDilutedGrowth',
    'dividendsperShareGrowth',
    'operatingCashFlowGrowth',
    'freeCashFlowGrowth',
    'receivablesGrowth',
    'inventoryGrowth',
    'assetGrowth',
    'bookValueperShareGrowth',
    'debtGrowth',
    'rdexpenseGrowth',
    'sgaexpensesGrowth',
    'tenYRevenueGrowthPerShare',
    'fiveYRevenueGrowthPerShare',
    'threeYRevenueGrowthPerShare',
    'tenYOperatingCFGrowthPerShare',
    'fiveYOperatingCFGrowthPerShare',
    'threeYOperatingCFGrowthPerShare',
    'tenYNetIncomeGrowthPerShare',
    'fiveYNetIncomeGrowthPerShare',
    'threeYNetIncomeGrowthPerShare',
    'tenYShareholdersEquityGrowthPerShare',
    'fiveYShareholdersEquityGrowthPerShare',
    'threeYShareholdersEquityGrowthPerShare',
    'tenYDividendperShareGrowthPerShare',
    'fiveYDividendperShareGrowthPerShare',
    'threeYDividendperShareGrowthPerShare',
];

export const multiplesLineItemOrdering = [
    // 'symbol',
    // 'date',
    // 'calendarYear',
    // 'period',
    'currentRatio',
    'quickRatio',
    'cashRatio',
    'daysOfSalesOutstanding',
    'daysOfInventoryOutstanding',
    'operatingCycle',
    'daysOfPayablesOutstanding',
    'cashConversionCycle',
    'grossProfitMargin',
    'operatingProfitMargin',
    'pretaxProfitMargin',
    'netProfitMargin',
    'effectiveTaxRate',
    'returnOnAssets',
    'returnOnEquity',
    'returnOnCapitalEmployed',
    'netIncomePerEBT',
    'ebtPerEbit',
    'ebitPerRevenue',
    'debtRatio',
    'debtEquityRatio',
    'longTermDebtToCapitalization',
    'totalDebtToCapitalization',
    'interestCoverage',
    'cashFlowToDebtRatio',
    'companyEquityMultiplier',
    'receivablesTurnover',
    'payablesTurnover',
    'inventoryTurnover',
    'fixedAssetTurnover',
    'assetTurnover',
    'operatingCashFlowPerShare',
    'freeCashFlowPerShare',
    'cashPerShare',
    'payoutRatio',
    'operatingCashFlowSalesRatio',
    'freeCashFlowOperatingCashFlowRatio',
    'cashFlowCoverageRatios',
    'shortTermCoverageRatios',
    'capitalExpenditureCoverageRatio',
    'dividendPaidAndCapexCoverageRatio',
    'dividendPayoutRatio',
    'priceBookValueRatio',
    'priceToBookRatio',
    'priceToSalesRatio',
    'priceEarningsRatio',
    'priceToFreeCashflowsRatio',
    'priceToOperatingCashflowsRatio',
    'priceCashFlowRatio',
    'priceEarningsToGrowthRatio',
    'priceSalesRatio',
    'dividendYield',
    'enterpriseValueMultiple',
    'priceFairValue',
];

export const dividendsLineItemOrdering = ['amount', 'splitAdjustedAmount', 'percentChange'];
